// extracted by mini-css-extract-plugin
export default {"container":"StepWithImage_container__+H5g+","image":"StepWithImage_image__FxZ7E","details":"StepWithImage_details__f1ChC"};